import { render, staticRenderFns } from "./OperacoesFilter.vue?vue&type=template&id=3becf8e1"
import script from "./OperacoesFilter.vue?vue&type=script&lang=js"
export * from "./OperacoesFilter.vue?vue&type=script&lang=js"
import style0 from "./OperacoesFilter.vue?vue&type=style&index=0&id=3becf8e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports